const payloadUser = {
    uid: -1,
    name: '',
    surname: '',
    password: '',
    password2: '',
    email: '',
    email2: '',
    phone: '',
    system_role: '',
    regione: '',
    provincia: '',
    comune: '',
    reference: ''
}

type loungeData = {
    stocks:  any | null
    subscriptions: [{
        id: string,
        stock_id: string,
        subscription_value: string,
        subscription_status: string,
        person_name: string,
        person_surname: string,
        person_fiscal_code: string,
        person_town: string
    }] | null
    stock_users: [{
        id: string,
        name: string,
        surname: string
    }] | null
}
type userData = {
    users: [
        uid: number,
        name: string,
        surname: string,
        password: string,
        password2: string,
        email: string,
        email2: string,
        phone: string,
        role: string,
        status: string,

        regione: string,
        provincia: string,
        comune: string
    ] | null
}

export {
    payloadUser,
    loungeData,
    userData
};
